<style scoped lang="scss">
    .desc-p {
        min-height: 6rem;
    }
</style>

<template>
<div class="uk-form" v-if="application && application.household">
    <div class="uk-grid" v-if="!print">
        <div class="uk-width-medium-3-5 uk-push-1-5 uk-margin-large-bottom">
            <div class="uk-panel-box"><strong>Understanding Gross vs Net:</strong> <small><br class="uk-margin-bottom"/>
                Gross income is the amount you earn before deductions are subtracted for insurance, taxes, Medicare, fees etc.. Net income is how much money is left after the deductions are subtracted. For this application, please enter your gross income for ALL income types.</small>
            </div>
        </div>
    </div>
    <ValidationObserver
        v-slot="{ handleSubmit, invalid, dirty }"
        ref="incomeForm"
    >
        <form class="uk-form" @submit.prevent="handleSubmit(create)" autocomplete="chrome-off">
            <div class="uk-grid">
                <div class="uk-width-1-1 uk-margin-large-bottom" v-if="householdMembersWithIncome[member.id]" v-for="member in household.members" :key="member.id" v-show="ageForMember(member) >= 18 && shouldShowMember(member.id)">
                    <legend>{{ member.first_name }} {{ member.last_name }}</legend>

                    <div class="uk-grid">
                        <div class="uk-width-small-1-1 uk-width-medium-1-2 uk-width-large-1-3 uk-margin-bottom">
                            <label>Select {{ member.first_name }}'s Proof of Income Type</label>
                            <select :value="householdMembersWithIncome[member.id].incomeProofType" @input="onIncomeTypeChange($event, member.id)" class="uk-select uk-width-1-1">
                                <option :value="null">Please Make a Selection...</option>
                                <option value="1040">Last Year's 1040 (Pages 1 & 2 Only)</option>
                                <option value="w2-1099" v-if="programSettings['uses-income-history-documents']">Last Year's Proof of Income (W2 / 1099 / K-1 / etc)</option>
                                <option value="last-days">Last {{ programSettings['required-days-of-income-proof'] }} Days of Income</option>
                                <option value="none">No Income</option>
                            </select>
                        </div>

                        <div class="uk-width-1-1 uk-margin-top" v-if="householdMembersWithIncome[member.id].incomeProofType === null || !householdMembersWithIncome[member.id].incomeProofType">
                            <div class="uk-grid">
                                <div class="uk-width-medium-1-4">

                                    <h3 class="uk-card-title">Upload Last Year's 1040</h3>
                                    <p class="desc-p">Using your 1040 gives you the highest probability of approval and allows to use AGI vs. Gross income, Add a link to IRS free file website.</p>

                                    <div class="uk-card-footer">
                                        <button type="button" class="uk-button uk-button-primary uk-width-1-1 verify-compensation-button" @click="onTypeButtonClick(member.id, '1040')" >Use 1040</button>
                                    </div>
                                </div>
                                <div class="uk-width-medium-1-4" v-if="programSettings['uses-income-history-documents']">

                                    <h3 class="uk-card-title">Upload Proof of Income</h3>
                                    <p class="desc-p">Upload proof of income...</p>

                                    <div class="uk-card-footer">
                                        <button type="button" class="uk-button uk-button-primary uk-width-1-1 verify-compensation-button" @click="onTypeButtonClick(member.id, 'w2-1099')" >Upload Proof of Income</button>
                                    </div>
                                </div>
                                <div class="uk-width-medium-1-4">

                                    <h3 class="uk-card-title">Last {{ programSettings['required-days-of-income-proof'] }} Days of income</h3>
                                    <p class="desc-p">Fill out my income, upload pay stubs, etc.</p>

                                    <div class="uk-card-footer">
                                        <button type="button" class="uk-button uk-button-primary uk-width-1-1 verify-compensation-button" @click="onTypeButtonClick(member.id, 'last-days')" >Fill Out Income</button>
                                    </div>
                                </div>
                                <div class="uk-width-medium-1-4">

                                    <h3 class="uk-card-title">I have no income</h3>
                                    <p class="desc-p">I certify that i have no income</p>

                                    <div class="uk-card-footer">
                                        <button type="button" class="uk-button uk-button-primary uk-width-1-1 verify-compensation-button" @click="onTypeButtonClick(member.id, 'none')" >I certify that i have no income</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="uk-width-1-1 uk-align-center" v-if="householdMembersWithIncome[member.id].incomeProofType === '1040'">
                            <irs1040-entry-form
                                    :members="household.members"
                                    :member="member"
                                    :label="member.first_name + ' ' + member.last_name"
                                    :url="uploadUrl"
                                    @includedMembersChanged="updatedIncludedMembers"
                                    @updated="onMemberIncomeChanged"
                                    :ref="`irs1040Form_${member.id}`"
                            ></irs1040-entry-form>
                        </div>

                        <div class="uk-width-1-1 uk-align-center" v-if="householdMembersWithIncome[member.id].incomeProofType === 'w2-1099' && programSettings['uses-income-history-documents']">
                            <w2-or1099-entry-form
                                @updated="onMemberIncomeChanged"
                                :member="member"
                                :label="member.first_name + ' ' + member.last_name"
                                :url="uploadUrl"
                                :ref="`w2Form_${member.id}`"
                            ></w2-or1099-entry-form>

                        </div>

                        <div class="uk-width-1-1 uk-align-center" v-if="householdMembersWithIncome[member.id].incomeProofType === 'last-days'">
                            <income-entry-form
                                @updated="onMemberIncomeChanged"
                                :values="householdMembersWithIncome[member.id].incomeValues"
                                :member="member"
                                :label="member.first_name + ' ' + member.last_name"
                                :url="uploadUrl"
                                :ref="`lastDaysForm_${member.id}`"
                            ></income-entry-form>
                        </div>
                    </div>

                </div>
                <div class="uk-width-1-1">
                    <div class="uk-grid" v-if="!hasHouseholdEarners">
                        <div class="uk-width-1-1">
                            <p>
                                If you declare that no one in your household receives a source of income you must provide a
                                statement on how you meet your MONTHLY living expenses:
                            </p>
                        </div>
                        <div class="uk-width-1-1">
                            <table class="uk-table uk-hidden-small uk-table-striped">
                                <thead>
                                <tr>
                                    <th>Monthly Expense</th>
                                    <th>Monthly Amount</th>
                                    <th>How does it get paid?</th>
                                    <th>Who pays it?</th>
                                    <th>Contact Phone</th>
                                    <th>Contact Email</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="incomeValue in zeroIncomeValues">
                                    <td>{{ incomeValue.label }}</td>
                                    <td>
                                        <vue-numeric currency="$" v-model="incomeValue.amount" type="text"></vue-numeric>
                                    </td>
                                    <td>
                                        <select v-model="incomeValue.method" placeholder="Select a method" class="uk-select">
                                            <option :value="null">Select a method</option>
                                            <option v-for="(label, value) in zeroIncomePaymentMethods" :value="value">{{ label }}</option>
                                        </select>
                                    </td>
                                    <td>
                                        <input type="text" v-model="incomeValue.payer">
                                    </td>
                                    <td>
                                        <input type="text" v-model="incomeValue.payer_phone">
                                    </td>
                                    <td>
                                        <input type="text" v-model="incomeValue.payer_email">
                                    </td>
                                </tr>
                                </tbody>
                            </table>

                            <div class="uk-grid uk-width-small-1-1 uk-hidden-medium uk-hidden-large uk-form uk-form-horizontal uk-form-stacked" v-for="incomeValue in zeroIncomeValues">
                                <div class="uk-width-1-1">
                                    <h4>
                                        {{ incomeValue.label }}
                                    </h4>
                                </div>
                                <div class="uk-width-1-2 uk-margin-top uk-margin-bottom">
                                    <div class="uk-form-row">
                                        <label class="uk-form-label" for="">Monthly Amount</label>
                                        <div class="uk-form-controls">
                                            <div>
                                                <vue-numeric currency="$" v-model="incomeValue.amount" type="text"></vue-numeric>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="uk-form-row">
                                        <label class="uk-form-label" for="">Who pays it?</label>
                                        <div class="uk-form-controls">
                                            <div>
                                                <input type="text" v-model="incomeValue.payer">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="uk-form-row">
                                        <label class="uk-form-label" for="">Contact Phone</label>
                                        <div class="uk-form-controls">
                                            <div>
                                                <input type="text" v-model="incomeValue.payer_phone">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="uk-width-1-2 uk-margin-top uk-margin-large-bottom">
                                    <div class="uk-form-row">
                                        <label class="uk-form-label" for="">How?</label>
                                        <div class="uk-form-controls">
                                            <select v-model="incomeValue.method" placeholder="Select a method" class="uk-select">
                                                <option :value="null">Select a method</option>
                                                <option v-for="(label, value) in zeroIncomePaymentMethods" :value="value">{{ label }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="uk-form-row">
                                        <label class="uk-form-label" for="">Contact Email</label>
                                        <div class="uk-form-controls">
                                            <div>
                                                <input type="text" v-model="incomeValue.payer_email">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="uk-width-1-1 uk-margin-large-top">
                    <h2 class="uk-text-right">Total Annualized Household Income: {{ totalRequested | formatMoney }}</h2>
                </div>
            </div>
        </form>
    </ValidationObserver>
    <modal-dialog
        title="Are you sure?"
        ref="confirmIncomeTypeModal"
        @close="onCloseModalConfirm"
        @confirm="onCompleteModalConfirm"
        confirmText="Confirm"
        :stuck="true"
    >
        Are you sure you want to change your income reporting method? You will lose the income information entered and it cannot be recovered.
    </modal-dialog>
</div>
</template>

<script>
    import IncomeEntryForm from "../../../../../components/AppWizard/Step3/IncomeEntryForm";
    import { mapState, mapGetters } from 'vuex';
    import Irs1040EntryForm from "../../../../../components/AppWizard/Step3/Irs1040EntryForm";
    import W2Or1099EntryForm from "../../../../../components/AppWizard/Step3/W2Or1099EntryForm";
    import ModalDialog from "../../../../../components/Common/ModalDialog";

    export default {
        name: "Step3",
        components: {W2Or1099EntryForm, Irs1040EntryForm, IncomeEntryForm, ModalDialog},
        props: {
            print: {
                default: false,
            }
        },
        data() {
            return {
                uploadUrl: "api/hope/documents",
                showTypeChangeAlertModal: false,
                primaryApplicantHasIncome: false,
                primaryApplicantIncomeValues: [],
                householdMembersWithIncome: {},
                zeroIncomePaymentMethods: {
                    gift: 'Gift',
                    loan: 'Loan',
                    other: 'Other',
                },
                zeroIncomeValues: [
                    {
                        name: 'housing',
                        label: 'Housing',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                    {
                        name: 'utilities',
                        label: 'Utilities',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                    {
                        name: 'food',
                        label: 'Food',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                    {
                        name: 'transportation',
                        label: 'Transportation',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                    {
                        name: 'phone',
                        label: 'Cell Phone',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                    {
                        name: 'personal',
                        label: 'Personal Expenses',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                    {
                        name: 'other',
                        label: 'Other Expenses',
                        amount: 0,
                        method: null,
                        payer: '',
                        payer_phone: '',
                        payer_email: '',
                    },
                ],

                hhMemberIdsIncludedInOtherDocs: {},
                incomeTypes: {
                    '1040': [ '1040' ],
                    'last-days': [ 'primary_monthly','secondary_monthly','tertiary_monthly','self_employment_monthly','service_pay','operation_business','self-employment','worker-compensation','interest','unemployment-benefit','ssi','annuities','insurance','alimony','regular_contribution','tanf','all_regular_pay' ],
                    'w2-1099': [ 'w2', 'k1', '1099-A', '1099-B', '1099-C', '1099-CAP', '1099-DIV', '1099-G', '1099-INT', '1099-K', '1099-LTC', '1099-MISC', '1099-OID', '1099-PATR', '1099-Q', '1099-R', '1099-SA' ],
                    'none': [ 'none' ]
                }
            }
        },
        watch: {
            application(newValue) {
                console.log(newValue)
                if(newValue.household) {
                    this.initData();
                }
            }
        },
        computed: {
            hasHouseholdEarners() {
                let hasEarners = false;
                if(this.primaryApplicantHasIncome) {
                    hasEarners = true;
                }
                for(let i in this.householdMembersWithIncome) {
                    let member = this.householdMembersWithIncome[i];
                    if(member.incomeProofType !== null && member.incomeProofType !== 'none') {
                        hasEarners = true;
                    }
                }
                return hasEarners;
            },
            household() {
                if(this.application && this.application.household) {
                    return this.application.household;
                }
            },
            totalRequested() {
                let total = 0;
                _.each(this.householdMembersWithIncome, member => {
                    const values = member.incomeValues.filter(item => this.incomeTypes[member.incomeProofType] && this.incomeTypes[member.incomeProofType].includes(item.type))
                    _.each(values, income => {
                        total += this.getAnnualIncomeFromIncomeValue(income)
                    })
                })
                return total;
            },
            ...mapState('Application', {
                application: state => state.application,
            }),
            ...mapGetters('Application', [ 'programSettings' ]),
        },
        mounted() {
            if(this.household) {
                this.initData();
            }
        },
        methods: {
            onCloseModalConfirm(data) {
                const {id, oldVal, newVal } = data
                this.householdMembersWithIncome[id].incomeProofType = newVal
                this.householdMembersWithIncome[id].incomeProofType = oldVal
            },

            onCompleteModalConfirm(data) {
                const {id, oldVal, newVal } = data
                this.householdMembersWithIncome[id].incomeProofType = newVal
            },

            onIncomeTypeChange(e, id) {
                if (this.householdMembersWithIncome[id].incomeProofType !== e.target.value)
                {
                    if (this.householdMembersWithIncome[id].incomeProofType)
                    {
                        this.$refs.confirmIncomeTypeModal.setData({
                            id: id,
                            oldVal: this.householdMembersWithIncome[id].incomeProofType,
                            newVal: e.target.value,
                        })
                        this.$refs.confirmIncomeTypeModal.open();
                    } else {
                        this.householdMembersWithIncome[id].incomeProofType = e.target.value
                    }
                }

                this.$nextTick(this.$forceUpdate);
            },

            onTypeButtonClick(id, type) {
                this.householdMembersWithIncome[id].incomeProofType = type
            },

            shouldShowMember(memberId) {
                for(var i in this.hhMemberIdsIncludedInOtherDocs) {
                    if(this.hhMemberIdsIncludedInOtherDocs[i].includes(memberId)) {
                        return false;
                    }
                }
                return true;
            },
            updatedIncludedMembers(payload) {
                console.log('Updating Included ', payload);
                if(payload.memberIds.length === 0) {
                    this.$set(this.hhMemberIdsIncludedInOtherDocs, payload.fromMember, []);
                }else {
                    if(this.hhMemberIdsIncludedInOtherDocs[payload.fromMember] === undefined) {
                        this.$set(this.hhMemberIdsIncludedInOtherDocs, payload.fromMember, []);
                    }
                    this.hhMemberIdsIncludedInOtherDocs[payload.fromMember] = payload.memberIds;
                }
            },
            initData() {
                this.generateMembersArray();

                _.each(this.application.zero_income_meta, meta => {
                    _.each(this.zeroIncomeValues, value => {
                        if(meta.name === value.name) {
                            value.amount = meta.amount;
                            value.method = meta.method;
                            value.payer = meta.payer;
                            value.payer_phone = meta.payer_phone;
                            value.payer_email = meta.payer_email;
                        }
                    })
                })
            },

            generateMembersArray() {
                this.householdMembersWithIncome = {};
                _.each(this.household.members, member => {
                    // get age
                    let dob = moment(member.birth_date);
                    let age = moment().diff(dob, 'years');
                    if(age < 18) return;

                    this.$set(this.householdMembersWithIncome, member.id, {
                        hasIncome: member.annual_income !== null && member.annual_income > 0,
                        incomeValues: member.incomes,
                        incomeProofType: member.income_type
                    });
                })
            },

            scrollTop: function () {
                if (window.pageYOffset > 0) {
                    this.intervalId = setInterval(() => {
                        if (window.pageYOffset === 0) {
                            clearInterval(this.intervalId)
                        }
                        window.scroll(0, window.pageYOffset - 50)
                    }, 5)
                }
            },

            async validateStep() {
                let stepValid = false;

                await this.$refs.incomeForm.validate().then(async (isValid) => {

                    const subFormValid = await this.checkFormValid();
                    if (isValid && subFormValid) {
                        await this.save();
                        stepValid = true
                    } else {
                        this.scrollTop()
                    }
                })
                return stepValid
            },
            async save() {
                let data = {
                    application: {
                        zero_income: this.hasHouseholdEarners ? 0 : 1,
                        zero_income_meta: (this.hasHouseholdEarners) ? null : JSON.stringify(this.zeroIncomeValues),
                    },
                    members: this.getHouseholdMemberData(),
                }

                return axios.put(`/api/hope/applications/${this.application.id}/step-3`, data)
                    .then((res) => {
                        this.$store.dispatch('Application/fetch', this.application.id)
                    })
                    .catch((error) => {
                    })
            },

            checkFormValid() {
                let isValid = true;
                _.each(this.householdMembersWithIncome, (member, id) => {
                    let refForm = undefined

                    switch (member.incomeProofType) {
                        case '1040':
                            refForm = this.$refs[`irs1040Form_${id}`][0]
                            break;
                        case 'w2-1099':
                            refForm = this.$refs[`w2Form_${id}`][0]
                            break;
                        case 'last-days':
                            refForm = this.$refs[`lastDaysForm_${id}`][0]
                            break;
                        default:
                            break;
                    }
                    if (refForm && typeof refForm['validate'] === 'function')
                        isValid = isValid && refForm.validate();

                });
                return isValid;
            },

            getHouseholdMemberData() {
                let data = {}
                let index = 0;
                _.each(this.householdMembersWithIncome, (member, id) => {
                    let refForm = undefined
                    let incomes = []

                    switch (member.incomeProofType) {
                        case '1040':
                            refForm = this.$refs[`irs1040Form_${id}`][0]
                            incomes = refForm ? [refForm.income]: [];
                            break;
                        case 'w2-1099':
                            refForm = this.$refs[`w2Form_${id}`][0]
                            incomes = refForm ? refForm.incomes: [];
                            break;
                        case 'last-days':
                            refForm = this.$refs[`lastDaysForm_${id}`][0]
                            incomes = refForm ? refForm.incomes: [];
                            break;
                        default:
                            break;
                    }

                    console.log(refForm)
                    data[id] = {
                        annual_income: this.getTotalRequestedForMember(member),
                        annual_income_meta: member.incomeValues,
                        incomes: incomes,
                        ...member
                    }
                    index++;
                })
                return data;
            },

            ageForMember(member) {
                return moment().diff(moment(member.birth_date), 'years');
            },
            checkboxUpdated() {
                window.setTimeout(() => this.$forceUpdate(), 200);
                // this.$nextTick(this.$forceUpdate);
            },

            getTotalRequestedForMember(member) {
                let total = 0;
                _.each(member.incomeValues, income => {
                    total += this.getAnnualIncomeFromIncomeValue(income)
                })
                return total;
            },

            getAnnualIncomeFromIncomeValue(income) {
                let amount = income.income_amount
                if (income.doc_type === 'paystub')
                {
                    amount = _.reduce(income.paystubs, (sum, item) => {
                        return sum + item.income_amount
                    }, 0);
                    amount = income.paystubs.length ? amount / income.paystubs.length : 0;
                    switch(income.interval) {
                        case 'monthly':
                        case 'other':
                            amount = parseFloat(amount) * 12;
                            break;

                        case 'weekly':
                            amount = parseFloat(amount) * 52;
                            break;

                        case 'biweekly':
                            amount = parseFloat(amount) * 26;
                            break;

                        case 'bimonthly':
                            amount = parseFloat(amount) * 24;
                            break;

                        case 'annually':
                            amount = parseFloat(amount);
                            break;

                        default: amount = parseFloat(amount) * 12;
                            break;
                    }
                }

                return amount ? amount:  0;

            },

            getTotalRequested() {
                let total = 0;
                _.each(this.householdMembersWithIncome, member => {
                    _.each(member.incomes, income => {
                        total += this.getAnnualIncomeFromIncomeValue(income)
                    })
                })
                return total;
            },

            onMemberIncomeChanged($event) {
                this.householdMembersWithIncome[$event.member.id]['incomeValues'] = $event.amounts;
                this.$nextTick(this.$forceUpdate);
            },
            onApplicantIncomeChanged($event) {
                this.primaryApplicantIncomeValues = $event.amounts;
                this.$nextTick(this.$forceUpdate);
            },
            MonthlyTotalIncome() {
                var totalMonthlyIncome = 0;
                var monthlyGrossWagesPrimaryJob = parseInt($('#financial-information-form').find('input[name="monthly-gross-wages-primary-job"]').val());
                /// ADD IN VARS DYNAMICALLY FOR EACH APPLICANT ADDED ON SECTION 2 FOR GRAND TOTAL ///

                var monthlyGrossWagesSecondJob = parseInt($('#financial-information-form').find('input[name="monthly-gross-wages-second-job"]').val());
                var monthlyGrossWagesThirdJob = parseInt($('#financial-information-form').find('input[name="monthly-gross-wages-third-job"]').val());
                var selfEmployment = parseInt($('#financial-information-form').find('input[name="self-employment"]').val());
                var alimony = parseInt($('#financial-information-form').find('input[name="alimony"]').val());
                var socialSecurityIncome = parseInt($('#financial-information-form').find('input[name="social-security-income"]').val());
                var socialSecurityDisability = parseInt($('#financial-information-form').find('input[name="social-security-disability"]').val());
                var unemploymentCompensation = parseInt($('#financial-information-form').find('input[name="unemployment-compensation"]').val());
                var otherGovernmentAssistance = parseInt($('#financial-information-form').find('input[name="other-government-assistance"]').val());
                var retirement = parseInt($('#financial-information-form').find('input[name="retirement"]').val());
                var annuityInvestment = parseInt($('#financial-information-form').find('input[name="annuity-investment"]').val());
                var rentFromRoommate = parseInt($('#financial-information-form').find('input[name="rent-from-roommate"]').val());
                var rentalPropertyIncome = parseInt($('#financial-information-form').find('input[name="rental-property-income"]').val());
                var contributionsFromFamilyOrFriends = parseInt($('#financial-information-form').find('input[name="contributions-from-family-or-friends"]').val());
                var other = parseInt($('#financial-information-form').find('input[name="other"]').val());
                totalMonthlyIncome = monthlyGrossWagesPrimaryJob + monthlyGrossWagesSecondJob + monthlyGrossWagesThirdJob + selfEmployment + alimony + socialSecurityIncome + socialSecurityDisability + unemploymentCompensation + otherGovernmentAssistance + retirement + annuityInvestment + rentFromRoommate + rentalPropertyIncome + contributionsFromFamilyOrFriends + other;
                $('#financial-information-form').find('input[name="total-monthly-income"]').val(totalMonthlyIncome);

            }
        }
    }
</script>
